import { useState } from 'react';
import { Alert, AlertTitle, Button, Box } from '@mui/material';
import { AutoFixHigh as WizardIcon } from '@mui/icons-material';
import { useWelcomeResumePrompt } from '../hooks/useWelcomeResumePrompt';

/**
 * Banner soft exibido no Dashboard quando a conta caiu no Admin sem ter
 * passado pelo Welcome (isNewUser flipou p/ false num 2º login) e está
 * completamente vazia. Oferece retomar o assistente, que recria tudo de uma
 * vez — inclusive os sites públicos que a criação manual não gera.
 *
 * Reusa a máquina existente do App.jsx via /?newuser=true. IMPORTANTE: usa
 * reload real (window.location), não o navigate do react-router — a detecção
 * de newuser roda no mount effect do App.jsx e não reage a navegação
 * client-side.
 *
 * @param {{ stats: object, loading: boolean }} props
 */
export default function WelcomeResumeBanner({ stats, loading }) {
  const { eligible, dismiss } = useWelcomeResumePrompt({ stats, loading });
  const [hidden, setHidden] = useState(false);

  if (!eligible || hidden) return null;

  const handleResume = () => {
    window.location.href = '/?newuser=true';
  };

  const handleDismiss = () => {
    dismiss();
    setHidden(true);
  };

  return (
    <Box sx={{ mb: 2 }}>
      <Alert
        severity="info"
        icon={<WizardIcon />}
        action={
          <>
            <Button color="inherit" size="small" onClick={handleDismiss}>
              Agora não
            </Button>
            <Button
              color="inherit"
              size="small"
              variant="outlined"
              onClick={handleResume}
              sx={{ ml: 1 }}
            >
              Retomar assistente
            </Button>
          </>
        }
      >
        <AlertTitle>Configure tudo de uma vez</AlertTitle>
        Sua conta ainda está vazia. O assistente cria profissionais, serviços,
        agenda e seus sites de agendamento automaticamente — em poucos cliques.
      </Alert>
    </Box>
  );
}
